module.exports = __webpack_public_path__ + "static/media/port.3495aacc.jpg";